import React from "react";
import { motion } from "framer-motion";
import peopleImg from "../../../images/People Working together.png";
import bgImg from "../../../images/bgImg.png";

const Index = () => {
  return (
    <div
      className="w-full py-16 px-6 py-24 relative overflow-hidden"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-aos="zoom-in"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 relative z-10">
        {/* Left Side - Illustration with Floating Effect */}
        <motion.div
          className="w-full md:w-1/2 flex justify-center"
          animate={{ y: [0, -10, 0] }}
          transition={{
            duration: 3,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
          }}
        >
          <img src={peopleImg} alt="Illustration" className="w-full max-w-md" />
        </motion.div>

        {/* Right Side - Text Content with Smooth Fade In */}
        <motion.div
          className="w-full md:w-1/2 text-white"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, ease: "easeOut", delay: 0.5 }}
        >
          <p className="text-[#F5C956] font-semibold uppercase tracking-wide">
            Our Vision
          </p>
          <h2 className="text-4xl font-bold leading-tight mt-2">
            Inclusivity, Understanding <br /> And Growth
          </h2>
          <p className="text-lg mt-4 opacity-80">
            We envision an Africa where language is no longer a barrier to
            connection and progress. NKENNEAi aims to make every African
            language accessible and valued in the digital world. By integrating
            these languages into modern technology, we promote inclusivity,
            understanding, and growth through innovative AI solutions.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Index;